import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export const UploadDialog = ({ folder, onClose, onSaved }) => {
  const [file, setFile] = useState(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Choose a file");
    setBusy(true);
    const fd = new FormData();
    fd.append("folder_id", folder.id);
    fd.append("name", name);
    fd.append("description", description);
    fd.append("file", file);
    try {
      const { data } = await api.post("/documents", fd);
      toast.success("Document uploaded");
      onSaved(data);
      onClose();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="upload-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Upload to {folder.name}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="space-y-1.5"><Label>File (max 25MB)</Label><Input type="file" required onChange={(e) => setFile(e.target.files[0])} data-testid="upload-file-input" /></div>
          <div className="space-y-1.5"><Label>Document title (defaults to file name)</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="upload-name-input" /></div>
          <div className="space-y-1.5"><Label>Description</Label><Textarea rows={2} value={description} onChange={(e) => setDescription(e.target.value)} data-testid="upload-description-input" /></div>
          <div className="flex justify-end">
            <button type="submit" disabled={busy} data-testid="upload-submit-btn" className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground disabled:opacity-60">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Upload
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
